// Login-session activity log: one Evt_UserLog row per login, refreshed by a
// 1-minute heartbeat so the last ping = effective logout time (usage tracking).
import { AddUserLog, UpdateUserLog } from '../api/api';
import { isNativeApp, devicePlatform, getDeviceName } from './deviceIdentity';

const LOG_KEY = 'se_logId';

export const getLogId = () => {
  const v = localStorage.getItem(LOG_KEY);
  return v ? Number(v) : null;
};
const setLogId = (id) => {
  if (id == null) localStorage.removeItem(LOG_KEY);
  else localStorage.setItem(LOG_KEY, String(id));
};

// MySQL datetime in the app's timezone (server also stamps, but we set both
// LoginTime and LogOutTime explicitly so a row is self-contained immediately).
function nowStamp() {
  const d = new Date();
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}

// Open a new session row at login. LoginTime + LogOutTime both = now (equal at
// first); the heartbeat advances LogOutTime. Best-effort: never blocks login.
export async function startSessionLog(user, deviceId) {
  try {
    const ts = nowStamp();
    const res = await AddUserLog({
      UserId: user.UserId,
      MobileNumber: user.MobileNumber || null,
      Platform: devicePlatform(),
      DeviceId: deviceId || (isNativeApp() ? null : getDeviceName()),
      LoginTime: ts,
      LogOutTime: ts,
      Valid: 1,
    });
    const id = res && res.insertId;
    if (id) setLogId(id);
    return id || null;
  } catch {
    return null;
  }
}

// Heartbeat: bump LogOutTime on the current session row. Called every minute.
export async function pingSessionLog() {
  const id = getLogId();
  if (!id) return;
  try {
    await UpdateUserLog({ data: { LogOutTime: nowStamp() }, where: `LogId = ${id}` });
  } catch { /* offline / transient — next ping will catch up */ }
}

// Final stamp on logout, then forget the row id.
export async function endSessionLog() {
  const id = getLogId();
  setLogId(null);
  if (!id) return;
  try {
    await UpdateUserLog({ data: { LogOutTime: nowStamp() }, where: `LogId = ${id}` });
  } catch { /* best-effort */ }
}
